import { useMediaQuery } from "@mui/material";
import { BudgetStatusEnum } from "../../../../enums/budgetStatus";
import { BudgetRecipientEnum, IBudgetFormData } from "../types";
import { downloadBudgetPdf } from "../../../../modules/downloadBudgetPdf";

interface IBudgetInfoBarProps {
  occurrenceProtocolNumber?: string;
  occurrenceContractNumber?: string;
  budgetNumber?: string;
  profile?: BudgetRecipientEnum;
  status?: BudgetStatusEnum;
  onViewAttachments?: () => void;
  budgetData?: IBudgetFormData;
  budgetId: string;
  onRemove?: () => void;
}

const BudgetInfoBar = (props: IBudgetInfoBarProps) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  const handleDownload = async () => {
    if (!props.budgetData) return;
    try {
      await downloadBudgetPdf(props.budgetData);
    } catch (error) {
      alert("Erro ao gerar PDF do orçamento");
    }
  };

  return (
    <div className={`mb-3 mt-3 ${isMobile ? "px-2" : "px-6"}`}>
      <div
        className={`flex ${isMobile ? "flex-col gap-3" : "items-center justify-between"} py-4 bg-white dark:bg-neutral-900 border-b border-t border-gray-200 dark:border-neutral-700`}
      >
        <div
          className={`flex ${isMobile ? "flex-col gap-2" : "items-center gap-4"} ${isMobile ? "text-size-12" : ""}`}
          style={{ fontFamily: "'Source Sans Pro', sans-serif" }}
        >
        {props.occurrenceProtocolNumber && (
          <span className="font-semibold text-[#344054] dark:text-neutral-200 text-size-16">
            {(props.occurrenceProtocolNumber || "").replace(/^OCOR-/, "OCOR ")}
          </span>
        )}
        {props.occurrenceProtocolNumber && props.occurrenceContractNumber && (
          <span className="font-normal text-gray-400 dark:text-neutral-500 mx-1">—</span>
        )}

        {props.occurrenceContractNumber && (
          <span className="font-bold text-[#344054] dark:text-neutral-200">
            Contrato {props.occurrenceContractNumber}
          </span>
        )}

        {(props.occurrenceProtocolNumber || props.occurrenceContractNumber) && props.budgetNumber && (
          <span className="font-normal text-gray-400 dark:text-neutral-500 mx-1">—</span>
        )}

        {props.budgetNumber && (
          <span className="font-semibold text-[#344054] dark:text-neutral-200 text-size-16">Orçamento #{props.budgetNumber}</span>
        )}

        {(props.occurrenceProtocolNumber || props.budgetNumber) && (
          <span className="font-normal text-gray-400 dark:text-neutral-500 mx-1">—</span>
        )}

        <span className="flex flex-row items-center gap-2">
          <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden className="shrink-0 text-gray-400 dark:text-neutral-500 mr-2">
            <path d="M6.65156 3.34961V5.34961H13.3516V5.34961H15.3516C15.6849 3.34961 15.9849 3.46628 16.2516 3.69961C16.5182 3.93294 16.6516 4.24961 16.6516 4.64961V16.0496C16.6516 16.3829 16.5182 16.6829 16.2516 16.9496C15.9849 17.2163 15.6849 17.3496 15.3516 17.3496H4.65156C4.31823 17.3496 4.01823 17.2163 3.75156 16.9496C3.4849 16.6829 3.35156 16.3829 3.35156 16.0496V4.64961C3.35156 4.24961 3.4849 3.93294 3.75156 3.69961C4.01823 3.46628 4.31823 3.34961 4.65156 3.34961H6.65156ZM11.3516 14.6496H6.05156C5.85156 14.6496 5.6849 14.7163 5.55156 14.8496C5.41823 14.9829 5.35156 15.1496 5.35156 15.3496C5.35156 15.5496 5.41823 15.7163 5.55156 15.8496C5.6849 15.9829 5.85156 16.0496 6.05156 16.0496H11.3516C11.5516 16.0496 11.7016 15.9829 11.8016 15.8496C11.9016 15.7163 11.9516 15.5496 11.9516 15.3496C11.9516 15.1496 11.9016 14.9829 11.8016 14.8496C11.7016 14.7163 11.5516 14.6496 11.3516 14.6496ZM13.3516 12.0496H6.05156C5.85156 12.0496 5.6849 12.0996 5.55156 12.1996C5.41823 12.2996 5.35156 12.4496 5.35156 12.6496C5.35156 12.8496 5.41823 13.0163 5.55156 13.1496C5.6849 13.2829 5.85156 13.3496 6.05156 13.3496H13.3516C13.5516 13.3496 13.7182 13.2829 13.8516 13.1496C13.9849 13.0163 14.0516 12.8496 14.0516 12.6496C14.0516 12.4496 13.9849 12.2996 13.8516 12.1996C13.7182 12.0996 13.5516 12.0496 13.3516 12.0496ZM12.1516 9.34961H6.05156C5.85156 9.34961 5.6849 9.41628 5.55156 9.54961C5.41823 9.68294 5.35156 9.81628 5.35156 9.94961V10.0496C5.35156 10.1829 5.41823 10.3163 5.55156 10.4496C5.6849 10.5829 5.85156 10.6496 6.05156 10.6496H12.1516C12.3516 10.6496 12.5016 10.5829 12.6016 10.4496C12.7016 10.3163 12.7516 10.1829 12.7516 10.0496V9.94961C12.7516 9.81628 12.7016 9.68294 12.6016 9.54961C12.5016 9.41628 12.3516 9.34961 12.1516 9.34961ZM13.9516 6.64961H6.05156C5.85156 6.64961 5.6849 6.71628 5.55156 6.84961C5.41823 6.98294 5.35156 7.14961 5.35156 7.34961C5.35156 7.54961 5.41823 7.69961 5.55156 7.79961C5.6849 7.89961 5.85156 7.94961 6.05156 7.94961H13.9516C14.1516 7.94961 14.3182 7.89961 14.4516 7.79961C14.5849 7.69961 14.6516 7.54961 14.6516 7.34961C14.6516 7.14961 14.5849 6.98294 14.4516 6.84961C14.3182 6.71628 14.1516 6.64961 13.9516 6.64961ZM12.6516 2.64961V4.64961H7.35156V2.64961H12.6516Z" fill="currentColor" />
          </svg>
          {props.onViewAttachments ? (
            <button
              type="button"
              className={`text-[#344054] dark:text-neutral-200 font-normal underline underline-offset-2 hover:opacity-80 bg-transparent border-none p-0 cursor-pointer text-left ${isMobile ? "text-size-12" : "text-size-14"} whitespace-nowrap`}
              onClick={props.onViewAttachments}
            >
              Visualizar anexos do chamado
            </button>
          ) : (
            <span className={`text-[#344054] dark:text-neutral-200 font-normal underline underline-offset-2 ${isMobile ? "text-size-12" : "text-size-14"} whitespace-nowrap`}>
              Visualizar anexos do chamado
            </span>
          )}
        </span>

        {props.onRemove && (
          <button
            type="button"
            className="btn btn-default btn-xs btn-icon-only ml-4 "
            onClick={props.onRemove}
          >
            <span className="rioglyph rioglyph-remove" aria-hidden="true" />
          </button>
        )}
        </div>
        {props.budgetData && (
          <button
          type="button"
          className={`${isMobile ? "p-1" : "p-2"} text-teal-600 hover:bg-teal-50 dark:hover:bg-teal-900/20 ${isMobile ? "self-start" : ""}`}
          aria-label="Download"
          onClick={handleDownload}
        >
          <img
            src="/assets/images/downloadFile.svg"
            alt="Download"
            className={isMobile ? "w-8 h-8" : "w-9 h-9"}
          />
          </button>
        )}
      </div>
    </div>
  );
};

export default BudgetInfoBar;
